import { useMemo } from "react";
import { getFormattedDateWithTime, getDateFromNow } from "@/helpers";
import type { AmlHistoryItemData } from "@/store";

import styles from "./CheckMadeOn.module.sass";

interface CheckMadeOnProps {
  isLoading?: boolean;
  item: AmlHistoryItemData;
}

const CheckMadeOn = (props: CheckMadeOnProps) => {
  const { item, isLoading } = props;

  const checkedFromNow = useMemo(
    () => getDateFromNow(item?.updated_at),
    [item],
  );

  const lastChecked = useMemo(
    () => getFormattedDateWithTime(item?.updated_at),
    [item],
  );

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonButton} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.box}>
      <div className={styles.date}>
        <div className={styles.date__title}>Report Generated</div>
        <table className={styles.date__list}>
          <tbody>
            <tr>
              <td>Last check</td>
              <td>
                <span>{checkedFromNow}</span>
              </td>
            </tr>
            <tr>
              <td>Timestamp</td>
              <td>
                <span>{lastChecked}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CheckMadeOn;
